import React from "react";
import { Box, CssBaseline } from "@mui/material";
import { ToastContainer } from "react-toastify";
import { GlobalLoading } from "react-global-loading";
import { PulseLoader } from "react-spinners";

/**
 * AuthLayout - Layout for authentication pages (login, register, etc.)
 * No sidebar, no header - just the content
 */
export default function AuthLayout({ children }) {
  return (
    <>
      <CssBaseline />
      <Box sx={{ minHeight: "100vh" }}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
          {children}
        </Box>

        <GlobalLoading zIndex={9999}>
          <PulseLoader color={"white"} size={30} />
        </GlobalLoading>
      </Box>
    </>
  );
}
